/*
* Pipeline Theme â€” Custom JS
* Amboria
*/

(function() {

  // 1. Auto-open cart drawer on add to cart (FIXED: wait for cart to reload)
  document.addEventListener('theme:cart:popdown', function() {
    var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (cartDrawer) {
      // Dispatch reload to force cart drawer to fetch fresh content
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      // Wait for cart HTML to be loaded before opening
      setTimeout(function() {
        cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
          bubbles: false
        }));
      }, 600);
    }
  });

  // 2. Invisible scrollbar for rich text blocks + non-heading title fix
  var scrollStyle = document.createElement('style');
  scrollStyle.textContent = [
    '.rte-scroll-wrapper { -ms-overflow-style: none; scrollbar-width: none; }',
    '.rte-scroll-wrapper::-webkit-scrollbar { display: none; }',
    'span.kicker-flourished, span.standard__heading, span.hero__title { display: block; font-family: var(--FONT-STACK-HEADING); font-style: var(--FONT-STYLE-HEADING); font-weight: var(--FONT-WEIGHT-HEADING); letter-spacing: var(--FONT-HEADING-LETTER-SPACING); text-transform: var(--FONT-HEADING-TRANSFORM); margin: 0 0 0.75em; }',
    'span.kicker-flourished { font-family: var(--TYPE-STACK-KICKER); font-style: var(--TYPE-STYLE-KICKER); font-weight: var(--TYPE-WEIGHT-KICKER); letter-spacing: var(--FONT-KICKER-LETTER-SPACING); text-transform: var(--FONT-KICKER-TRANSFORM); }'
  ].join('\n');
  document.head.appendChild(scrollStyle);

  // 3. Global heading size overrides
  var headingStyle = document.createElement('style');
  headingStyle.textContent = [
    'h1 { font-size: calc(var(--font-9) * var(--FONT-ADJUST-HEADING)) !important; }',
    'h2 { font-size: calc(var(--font-7) * var(--FONT-ADJUST-HEADING)) !important; }',
    'h3 { font-size: calc(var(--font-6) * var(--FONT-ADJUST-HEADING)) !important; }',
    'h4 { font-size: calc(var(--font-5) * var(--FONT-ADJUST-HEADING)) !important; }',
    'h5 { font-size: calc(var(--font-4) * var(--FONT-ADJUST-HEADING)) !important; }',
    'h6 { font-size: calc(var(--font-3) * var(--FONT-ADJUST-HEADING)) !important; }'
  ].join('\n');
  document.head.appendChild(headingStyle);

  // 4. Footer newsletter top alignment + logo spacing
  var footerStyle = document.createElement('style');
  footerStyle.textContent = [
    '.footer__newsletter__body:first-child { align-self: flex-start !important; }',
    '.footer__newsletter__body .footer__logo__wrapper { margin-top: 20px; }'
  ].join('\n');
  document.head.appendChild(footerStyle);

  // 5. Cart drawer checkout button alignment
  var cartStyle = document.createElement('style');
  cartStyle.textContent = [
    '#cart-form { padding: 0 8px; }',
    '@media (min-width: 480px) { #cart-form { padding: 0 12px; } }',
    '#cart-form .checkout__button { border-radius: 5px; }'
  ].join('\n');
  document.head.appendChild(cartStyle);

  // 6. Product description: link styling (bold + underline) + upsell/related title styling
  var descStyle = document.createElement('style');
  descStyle.textContent = [
    '/* Links in product description: bold + underline for SEO internal linking */',
    '.product__block__text--description a { font-weight: 700; text-decoration: underline; text-underline-offset: 3px; text-decoration-thickness: 1px; }',
    '.product__block__text--description a:hover { text-decoration-thickness: 2px; opacity: 0.8; }',
    '/* Headings in description: space above, tight below */',
    '.product__block__text--description h2, .product__block__text--description h3, .product__block__text--description h4 { margin-top: 0.8em; margin-bottom: 0.2em; }',
    '.product__block__text--description h2:first-child, .product__block__text--description h3:first-child { margin-top: 0; }',
    '/* Upsell title style preserved without H2 */',
    'p.upsell__holder__title__text { font-family: var(--FONT-STACK-HEADING); font-style: var(--FONT-STYLE-HEADING); font-weight: var(--FONT-WEIGHT-HEADING); letter-spacing: var(--FONT-HEADING-LETTER-SPACING); text-transform: var(--FONT-HEADING-TRANSFORM); font-size: calc(var(--font-5) * var(--FONT-ADJUST-HEADING)); margin: 0; }',
    '/* Related section title style preserved without H2 */',
    'p.kicker-flourished { font-family: var(--TYPE-STACK-KICKER); font-style: var(--TYPE-STYLE-KICKER); font-weight: var(--TYPE-WEIGHT-KICKER); letter-spacing: var(--FONT-KICKER-LETTER-SPACING); text-transform: var(--FONT-KICKER-TRANSFORM); font-size: calc(var(--font-7) * var(--FONT-ADJUST-HEADING)); display: block; }'
  ].join('\n');
  document.head.appendChild(descStyle);

})();